<template>
  <table class="w-full text-sm">
    <thead>
      <tr
        class="text-left text-light-disabled-text dark:text-dark-disabled-text"
      >
        <th class="pb-2 font-medium">Seriennummer</th>
        <th class="pb-2 font-medium">BLE</th>
        <th class="pb-2 font-medium">LTE (Backend)</th>
        <th class="pb-2 font-medium"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="gw in gateways"
        :key="gw.serialNumber"
        class="border-t border-light-3 dark:border-dark-3"
      >
        <td class="py-2">{{ gw.serialNumber }}</td>
        <td class="py-2">
          <div class="flex items-center gap-1">
            <DmgwSignalBars :rssi="gw.rssi" :thresholds="[-55, -75]" />
            <span
              class="text-[10px] text-light-disabled-text dark:text-dark-disabled-text"
            >
              {{ gw.rssi }} dBm
            </span>
          </div>
        </td>
        <td class="py-2">
          <template v-if="gw.serialNumber in lteRssi">
            <div
              v-if="lteRssi[gw.serialNumber] != null"
              class="flex items-center gap-1"
            >
              <DmgwSignalBars
                :rssi="lteRssi[gw.serialNumber]!"
                :thresholds="[-65, -85]"
              />
              <span
                class="text-[10px] text-light-disabled-text dark:text-dark-disabled-text"
              >
                {{ lteRssi[gw.serialNumber] }} dBm
              </span>
            </div>
            <span
              v-else
              class="text-xs text-light-disabled-text dark:text-dark-disabled-text"
              >-</span
            >
          </template>
          <em
            v-else
            class="mdi mdi-loading mdi-spin text-light-disabled-text dark:text-dark-disabled-text"
          />
        </td>
        <td class="py-2 text-right">
          <button
            class="rounded-full px-5 py-1.5 text-sm font-bold whitespace-nowrap"
            :class="
              hasAesKey(gw.serialNumber)
                ? 'bg-primary-2 text-white hover:bg-primary-1'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            "
            :disabled="!hasAesKey(gw.serialNumber)"
            @click="$emit('select', gw)"
          >
            Auslesen
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import type { DiscoveredGateway } from '@/native/plugins/QTool';
import DmgwSignalBars from './DmgwSignalBars.vue';

const props = defineProps<{
  gateways: DiscoveredGateway[];
  lteRssi: Record<string, number | null>;
  aesKeys: Record<string, string | null>;
}>();

defineEmits<{
  select: [gateway: DiscoveredGateway];
}>();

function hasAesKey(serial: string): boolean {
  return serial in props.aesKeys && props.aesKeys[serial] != null;
}
</script>
